module.exports = __webpack_public_path__ + "img/thumb_pepa006.70276c50.png";